import { ShapesIcon as PhosphorShapesIcon } from "@phosphor-icons/react/dist/ssr/Shapes";

import { createAppIcon } from "@/components/createAppIcon";

export const CategoryIcon = /* @__PURE__ */ createAppIcon(PhosphorShapesIcon);
